import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/Smartphone";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const mobileApps: ResourceProps = {
  name: Resource.MOBILE_APP,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Mobile App",
  },
};

export default mobileApps;
